import remarkParse from 'remark'
import remarkDisabledBlock from 'remark-disable-tokenizers'

import color from '../tokenizers/color'
import emoji from '../tokenizers/emoji'
import link from '../tokenizers/link'
import newline from '../tokenizers/newline'
import mention from '../tokenizers/mention'

import { createMarkdownComponent } from '../Components'

const parser = remarkParse()
  .use(emoji)
  .use(mention)
  .use(newline)
  .use(link)
  .use(color)
  .use(remarkDisabledBlock, {
    block: [
      'atxHeading',
      'definition',
      'footnote',
      'html',
      'setextHeading',
      'table',
    ],
    inline: ['html', 'reference', 'link'],
  })

const defaultMarkdownParser = content =>
  parser.parse(content).children.map(createMarkdownComponent)

export default defaultMarkdownParser
